import BaseApi from "@/api/BaseApi";
import axios from "axios";

export default class AccountApi {
    async getAddresses (address) {
        return axios.post(`https://reverse.geocoder.api.here.com/6.2/multi-reversegeocode.json?mode=retrieveAddresses&gen=9&app_id=${this.app_id}&app_code=${this.app_code}`, address, {
            headers: {
                'Content-Type': 'text/plain'
            }
        })
    }
}
